import React from "react";
import { AccordionItem } from "Components/Accordion";
import {
  getAwsVideoUrl,
  getVimeoVideoUrl,
  getYoutubeVideoUrl,
} from "Components/Videoviewer/Videoviewer";
import { createUseStyles } from "react-jss";
import styles from "./styles";

interface VideoMedia {
  id: number;
  title?: string;
  description?: string;
  type: string;
  url: string;
  videoid: string;
  network?: string;
}

interface Props {
  videos: VideoMedia[] | undefined;
  id: string;
}

const getVideo = (videoMedia: VideoMedia) => {
  const videoWidth = "800px";
  const videoHeight = "450px";
  const instagramHeight = "650px";
  let url: string;
  if (videoMedia.network === "instagram") {
    return (
      <iframe
        src={`https://www.instagram.com/p/${videoMedia.videoid}/embed`}
        title="Instagram video player"
        frameBorder="0"
        scrolling="true"
        width={videoWidth}
        height={instagramHeight}
        style={{
          maxWidth: videoWidth,
          maxHeight: instagramHeight,
          width: "100%",
        }}
        data-testid={`instagram-video-${videoMedia.videoid}`}
      />
    );
  }
  switch (videoMedia.type) {
    case "aws":
      url = getAwsVideoUrl(videoMedia);
      return (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video
          controls
          src={url}
          style={{
            maxWidth: videoWidth,
            maxHeight: videoHeight,
            width: "100%",
          }}
          data-testid={`aws-video-${videoMedia.videoid}`}
        />
      );
    case "vimeo":
      url = getVimeoVideoUrl(videoMedia);
      return (
        <iframe
          src={url}
          title="Vimeo video player"
          frameBorder="0"
          allowFullScreen
          width={videoWidth}
          height={videoHeight}
          style={{
            maxWidth: videoWidth,
            maxHeight: videoHeight,
            width: "100%",
          }}
          data-testid={`vimeo-video-${videoMedia.videoid}`}
        />
      );
    case "youtube":
      url = getYoutubeVideoUrl(videoMedia);
      return (
        <iframe
          src={url}
          title="Youtube video player"
          frameBorder="0"
          allowFullScreen
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          width={videoWidth}
          height={videoHeight}
          style={{
            maxWidth: videoWidth,
            maxHeight: videoHeight,
            width: "100%",
          }}
          data-testid={`youtube-video-${videoMedia.videoid}`}
        />
      );
    default:
      return <div>Video Type Not Found</div>;
  }
};

const ADADestinationVideos = (props: Props) => {
  const { videos, id } = props;
  const useStyles = createUseStyles(styles);
  const classes = useStyles();

  if (videos === undefined || videos.length === 0) {
    return null;
  }

  return (
    <AccordionItem id={id} title="Videos" headingLevel={4}>
      {videos.map((video) => (
        <React.Fragment key={video.id}>
          <h5 className={classes.videoHeading}>{video.title}</h5>
          <div className={classes.video}>{getVideo(video)}</div>
          <p className={classes.videoDescription}>{video.description}</p>
        </React.Fragment>
      ))}
    </AccordionItem>
  );
};

export default ADADestinationVideos;
